import { OperationLog } from '@rossum/mdh-api-client';

export const getTransformedOperationsData = (data: OperationLog) => {
  return {
    ...data,
    id: data._id,
    document_name:
      'file_metadata' in data.metadata
        ? (data.metadata as { file_metadata: { filename: string } })
            .file_metadata.filename
        : '',
    created: data.created ? new Date(data.created) : null,
    updated: data.updated ? new Date(data.updated) : null,
    records:
      'operation_summary' in data.metadata
        ? (data.metadata as { operation_summary: { record_count: number } })
            .operation_summary.record_count
        : 0,
  };
};

export type TransformedOperation = ReturnType<
  typeof getTransformedOperationsData
>;
